/**
 * @generated SignedSource<<ca0dd0429a03b8a475a1ed6338627a73>>
 * @relayHash 4b89602f9e622ea3a2871167b17a2f2c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cae59ee6f9e6e94700d07064e410118ec9e313798958b7ed0894c8464260e72d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AsyncMenuWithQueryQuery } from './AsyncMenuWithQueryQuery.graphql';

const node: PreloadableConcreteRequest<AsyncMenuWithQueryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cae59ee6f9e6e94700d07064e410118ec9e313798958b7ed0894c8464260e72d",
    "metadata": {},
    "name": "AsyncMenuWithQueryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
